const initialState = {
    employees: {},
    employee_properties: [],
    structures: {},
    devices: {},
    view_settings: {
        auto_update: true,
        template: 'grid',
        show_last_hours: 9,
        show_intervals: [],
        intervals: [],
        my_intervals: [],
        sort_by: 'passage_dt',
        display_in_control: [],
        display_in_block: [],
        sort_type: 'descending',
        show_in_card: [],
        structures: [],
        terminal_id: [],
    },
}

export const SET_TEMPLATE = 'SET_TEMPLATE';
export const SAVE_EMPLOYEES = 'SAVE_EMPLOYEES';
export const SET_EMPLOYEE_PROPS = 'SET_EMPLOYEE_PROPS';
export const SET_SHOW_INTERVALS = 'SET_SHOW_INTERVALS';
export const SET_INTERVALS = 'SET_INTERVALS';
export const SET_MY_INTERVALS = 'SET_MY_INTERVALS';
export const SET_STRUCTURE = 'SET_STRUCTURE';
export const SET_DEVICES = 'SET_DEVICES';
export const SAVE_VIEW_SETTINGS = 'SAVE_VIEW_SETTINGS';

export default function lampReduser(state = initialState, action) {
    switch (action.type) {
        case SET_TEMPLATE:
            return {
                ...state,
                view_settings: {
                    ...state.view_settings,
                    template: action.template
                },
            }
        case SAVE_EMPLOYEES:
            return {
                ...state,
                employees: action.employees,
            }
        case SET_EMPLOYEE_PROPS:
            return {
                ...state,
                employee_properties: action.employee_properties,
            }
        case SET_STRUCTURE:
            return {
                ...state,
                structures: action.structures,
            }
        case SET_DEVICES:
            return {
                ...state,
                devices: action.devices,
            }
        case SET_SHOW_INTERVALS:
            return {
                ...state,
                view_settings: {
                    ...state.view_settings,
                    show_intervals: action.show_intervals,
                }
            }
        case SET_INTERVALS:
            return {
                ...state,
                view_settings: {
                    ...state.view_settings,
                    intervals: action.intervals,
                }
            }
        case SET_MY_INTERVALS:
            return {
                ...state,
                view_settings: {
                    ...state.view_settings,
                    my_intervals: action.my_intervals,
                }
            }
        case SAVE_VIEW_SETTINGS:
            let view_settings = action.view_settings;
            if (view_settings.hasOwnProperty('structures')) view_settings.structures = JSON.parse(view_settings.structures);
            if (view_settings.hasOwnProperty('show_in_card')) view_settings.show_in_card = JSON.parse(view_settings.show_in_card);
            if (view_settings.hasOwnProperty('show_intervals')) view_settings.show_intervals = JSON.parse(view_settings.show_intervals);
            if (view_settings.hasOwnProperty('intervals')) view_settings.intervals = JSON.parse(view_settings.intervals);
            if (view_settings.hasOwnProperty('my_intervals')) view_settings.my_intervals = JSON.parse(view_settings.my_intervals);
            if (view_settings.hasOwnProperty('display_in_control')) view_settings.display_in_control = JSON.parse(view_settings.display_in_control);
            if (view_settings.hasOwnProperty('display_in_block')) view_settings.display_in_block = JSON.parse(view_settings.display_in_block);
            if (view_settings.hasOwnProperty('terminal_id')) view_settings.terminal_id = JSON.parse(view_settings.terminal_id);
            return {
                ...state,
                view_settings: {...view_settings},
            }
        default:
            return state;
    }
}

export const setTemplateLamp = (dispatch, template) => dispatch({type: SET_TEMPLATE, template: template});
export const saveEmployees = (dispatch, employees) => dispatch({type: SAVE_EMPLOYEES, employees: employees});
export const setShowIntervals = (dispatch, show_intervals) => dispatch({type: SET_SHOW_INTERVALS, show_intervals: show_intervals});
export const setIntervals = (dispatch, intervals) => dispatch({type: SET_INTERVALS, intervals: intervals});
export const setMyIntervals = (dispatch, my_intervals) => dispatch({type: SET_MY_INTERVALS, my_intervals: my_intervals});
export const saveEmployeeProps = (dispatch, employee_properties) => dispatch({type: SET_EMPLOYEE_PROPS, employee_properties: employee_properties});
export const saveStructure = (dispatch, structures) => {
    const toTree = require('./../helpers/functions').toTree;
    let tree_structures = toTree(structures);
    dispatch({type: SET_STRUCTURE, structures: tree_structures});
}
export const saveDevices = (dispatch, devices) => dispatch({type: SET_DEVICES, devices: devices});
export const saveViewSettings = (dispatch, settings) => dispatch({type: SAVE_VIEW_SETTINGS, view_settings: settings});